export default [
    {
        path: "surveys",
        redirect: "/surveys/list",
        name: "Khảo sát",
        component: {
            render(c) {
                return c("router-view");
            },
        },
        children: [
            {
                path: "list",
                name: "Danh sách khảo sát",
                component: () =>
                    import(
                        "@/views/screens/surveys/SurveyManagement"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Danh sách khảo sát"
                },
            },
            {
                path: "create",
                name: "Tạo khảo sát",
                component: () =>
                    import("@/views/screens/surveys/SurveyMaker"),
                meta: {
                    requiresAuth: true,
                    title: "Tạo khảo sát"
                },
            },
            {
                path: "participate/:id",
                name: "Thực hiện khảo sát",
                component: () =>
                    import(
                        "@/views/screens/surveys/SurveyParticipate"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Thực hiện khảo sát"
                },
            },
            {
                path: "result/:id",
                name: "Kết quả khảo sát",
                component: () =>
                    import("@/views/screens/surveys/SurveyResult"),
                meta: {
                    requiresAuth: true,
                    title: "Kết quả khảo sát"
                },
            },
        ],
    }
]